var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comSelect-container" },
    [
      _c(
        "Weforsys-TreeSelect",
        _vm._g(
          {
            attrs: {
              options: _vm.treeData,
              placeholder: _vm.placeholder,
              clearable: "",
              disabled: _vm.disabled,
              lastLevel: "",
            },
            model: {
              value: _vm.innerValue,
              callback: function ($$v) {
                _vm.innerValue = $$v
              },
              expression: "innerValue",
            },
          },
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }